var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 12.8309C23.75 16.3886 19.3468 22.2806 16.7875 25.4047C15.8511 26.5477 14.1489 26.5477 13.2125 25.4047C10.6533 22.2806 6.25 16.3886 6.25 12.8309C6.25 7.81565 10.1675 3.75 15 3.75C19.8325 3.75 23.75 7.81565 23.75 12.8309Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2505 12.5001C18.2505 14.2949 16.7954 15.7501 15.0005 15.7501C13.2056 15.7501 11.7505 14.2949 11.7505 12.5001C11.7505 10.7051 13.2056 9.25 15.0005 9.25C16.7954 9.25 18.2505 10.7051 18.2505 12.5001Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.ab0f19e39dd2a7d4ef5f5546dd5bda0c.svg";
export { ForwardRef as ReactComponent };